import { InjectionToken, inject } from '@angular/core';
import { Nullable } from '@redngapps/shared/types';

import { WINDOW } from './window.token';

/**
 * Injection token for the browser `Location` object (DEV-20131).
 *
 * Derives its value from the {@link WINDOW} token so that tests can either
 * provide `LOCATION` directly or provide a `WINDOW` mock with a `location`
 * property. Resolves to `null` outside of a browser context.
 */
export const LOCATION = new InjectionToken<Nullable<Location>>('LocationToken', {
  factory: () => {
    const windowRef = inject(WINDOW);

    if ('location' in windowRef) {
      return windowRef.location;
    }

    return null;
  },
});
